import { render, staticRenderFns } from "./IntakeDispStep.vue?vue&type=template&id=1308d12f"
import script from "./IntakeDispStep.vue?vue&type=script&lang=js"
export * from "./IntakeDispStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports